import BaseModal from 'components/Modals/BaseModal';
import s from 'components/Modals/BaseModal.module.css';
import l from 'components/Modals/LoginModal.module.css';

const DeleteListModal = ({ onClose, listName, onDelete, deleteLoading }) => {
    return (
        <BaseModal height="18rem" width="28rem" onClose={onClose}>
            <div className={l.loginModalContainer}>
                <div className={l.title}>Delete list?</div>
                <div className={l.subtitle}>
                    Are you sure you want to delete the list: <strong>{listName}</strong>?
                    <br />
                    <br />
                    Your contacts will still be saved, but no longer under this list.
                </div>
                <div style={{ display: 'flex', gap: '0.75rem', marginTop: '1.5rem' }}>
                    <div className={`${s.button} ${l.button}`} onClick={onClose}>
                        Cancel
                    </div>
                    <div
                        className={`${s.blackButton} ${l.button}`}
                        onClick={deleteLoading ? undefined : onDelete}
                        style={{ opacity: deleteLoading ? 0.7 : 1 }}
                    >
                        {deleteLoading ? 'Deleting…' : 'Delete'}
                    </div>
                </div>
            </div>
        </BaseModal>
    );
};

export default DeleteListModal;

